import type { PostHogConfig } from 'posthog-js';

export interface BasePostHogOptionsParams {
  host: string;
}

// Shared posthog.init options; each app spreads this and adds its own.
// `autocapture` is intentionally absent so apps opt in explicitly.
export function basePostHogClientOptions({
  host,
}: BasePostHogOptionsParams): Partial<PostHogConfig> {
  return {
    api_host: '/ingest',
    ui_host: host,
    // '2026-01-30' defaults inject lazy-loaded scripts into <head> not <body>, avoiding
    // a Next.js hydration mismatch — https://github.com/PostHog/posthog-js/issues/1645
    defaults: '2026-01-30',
    capture_exceptions: true,
    disable_surveys: true,
    capture_pageview: true,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    advanced_disable_feature_flags: true,
    advanced_disable_feature_flags_on_first_load: true,
    // Defer extension init to the next macrotask so lazy scripts aren't injected mid-hydration.
    __preview_deferred_init_extensions: true,
  };
}
